<template>
  <el-table :data="records" stripe size="mini" v-loading="loading" empty-text="Nenhum acesso de admin nesta conta">
    <el-table-column label="Data" width="160">
      <template slot-scope="scope">{{ scope.row.createdAt | formatDateHour }}</template>
    </el-table-column>
    <el-table-column label="Admin" width="200">
      <template slot-scope="scope">{{ scope.row.adminName }} ({{ scope.row.adminUsername }})</template>
    </el-table-column>
    <el-table-column label="Ação" width="90" prop="method"></el-table-column>
    <el-table-column label="Rota" prop="route" show-overflow-tooltip></el-table-column>
    <el-table-column label="Status" width="80" prop="status"></el-table-column>
    <el-table-column type="expand">
      <template slot-scope="scope">
        <pre class="admin-access-detail">{{ scope.row.payload | json }}</pre>
        <pre class="admin-access-detail">{{ scope.row.response }}</pre>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { UserService } from "@/services/users/user.services";

// Trilha do ENTRAR: o que um admin fez dentro desta conta (tabela `log_acesso_admin`).
export default {
  name: "UserAdminAccess",
  props: {
    userId: String,
  },
  filters: {
    json: (value) => (value ? JSON.stringify(value, null, 2) : ""),
  },
  data() {
    return {
      loading: false,
      records: [],
    };
  },
  mounted() {
    this.loading = true;
    UserService.impersonationHistory(this.userId)
      .then((records) => (this.records = records))
      .catch((error) => this.$message({ type: "error", message: error }))
      .finally(() => (this.loading = false));
  },
};
</script>
<style scoped>
.admin-access-detail {
  margin: 0 0 8px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
